import { getMessageClassName } from "shared/functions";

function JumpingDots() {
  const messageClassName = getMessageClassName(false);

  return (
    <div id="jumping-dots" className={messageClassName}>
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className="jumping-dot">
          &nbsp;
        </div>
      ))}
    </div>
  );
}

export default JumpingDots;
